import React from 'react'
import CardWidget, { Colors } from '../../../../components/CardWidget'
import CardWidgetSkeleton from '../../../../components/skeletons/CardWidgetSkeleton'
import { formatCurrency, formatNumber } from '../../../../utils/Helpers'

type Props = {
  multipleShoppingCartCancelledGMV: number,
  multipleShoppingCartCancelledQuantity: number
}

const MultipleShoppingCartCancelled = ({
  multipleShoppingCartCancelledGMV,
  multipleShoppingCartCancelledQuantity
}: Props): JSX.Element => {
  if (multipleShoppingCartCancelledGMV && !multipleShoppingCartCancelledQuantity) return <CardWidgetSkeleton />

  return (
    <CardWidget title={`Pedidos cancelados (${formatNumber(multipleShoppingCartCancelledQuantity, 0)} itens)`} number={`${formatCurrency(multipleShoppingCartCancelledGMV)}`} color={Colors.red} />
  )
}

export default MultipleShoppingCartCancelled
